<template>
<div>
    <b-row>
        <b-col>
            <h1>Overview Page</h1>

        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <b-card-group deck>
                <b-card header="featured" header-tag="header" footer="Card Footer" footer-tag="footer" :title="clientName">
                    <b-card-text>
                        Age
                    </b-card-text>
                    <b-card-text>
                        Contact Name
                    </b-card-text>
                    <b-card-text>
                        Contact Email
                    </b-card-text>
                    <b-card-text>
                        Account Manager
                    </b-card-text>
                    <b-card-text>
                        Status
                    </b-card-text>
                    <b-button href="#" variant="primary">Go somewhere</b-button>
                </b-card>

                <b-card title="Orders to date" header-tag="header" footer-tag="footer">
                    <template v-slot:header>
                        <h6 class="mb-0">Orders</h6>
                    </template>
                    <b-card-text>Total IDD+ Ordered</b-card-text>
                    <b-card-text>Total EDD Ordered</b-card-text>
                    <b-card-text>Total IDD Remedation Ordered</b-card-text>
                    <b-card-text>Total IDD+ Remedation Ordered</b-card-text>
                    <b-button href="#" variant="primary">Go somewhere</b-button>
                    <template v-slot:footer>
                        <em>Footer Slot</em>
                    </template>
                </b-card>
            </b-card-group>
        </b-col>
    </b-row>

</div>
</template>

<script>
// import {Helper} from "../../helpers";
import AppHeader from "../../components/header/header";
import moment from "moment";
import {
    HTTP
} from '../../utils/HTTP';
export default {
    name: "ClientProfileOverview",
    components: {
        AppHeader
    },
    data() {
        return {
            clientId:null,
          
            isLoading: false,
            clientName:null,
           

        }
    },

    computed: {

    },
    methods: {
        async getClientData() {
      
        let ajaxPostParameters = {
            companyId: this.clientId,
            startDate: moment()
          .subtract(1, "months")
          .startOf("month"),
        endDate: moment()
          .subtract(1, "months")
          .endOf("month")
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/reports/getalldata", ajaxPostParameters, {
        Authorization: token
      });
// console.log(result);
      //this.clientName = result.data.company_name;
      
     return;
        
    },
    },
    mounted(){
       this.clientId = this.$route.params.id; 
       this.getClientData();
        
    }
}
</script>

<style scoped>

</style>
